// app/javascript/controllers/dae20/copy_suggestions_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["suggestion", "input"]
  static classes = ["active"]
  static values = {
    separator: { type: String, default: "," },
    append: { type: Boolean, default: true }
  }

  connect() {
    // Инициализация при подключении контроллера
    console.log("CopySuggestions controller connected")
  }

  // Метод для копирования значения из span в input
  copy(event) {
    const suggestionValue = event.currentTarget.getAttribute("data-value") ||
      event.currentTarget.textContent.trim()

    if (!suggestionValue) return

    const inputElement = this.inputTarget
    const separator = this.separatorValue
    const append = this.appendValue

    // Получаем текущее значение input
    let currentValue = inputElement.value.trim()

    // Если append = true, добавляем к существующему значению
    if (append && currentValue) {
      // Проверяем, есть ли уже это значение
      const values = currentValue.split(separator).map(v => v.trim())
      if (!values.includes(suggestionValue)) {
        // Добавляем новое значение
        inputElement.value = values.concat([suggestionValue]).join(separator)
      }
    } else {
      // Заменяем значение
      inputElement.value = suggestionValue
    }

    // Устанавливаем фокус на input
    inputElement.focus()

    // Добавляем класс активности для визуальной обратной связи
    if (this.hasActiveClass) {
      event.currentTarget.classList.add(this.activeClass)
      setTimeout(() => {
        event.currentTarget.classList.remove(this.activeClass)
      }, 300)
    }

    // Триггерим событие изменения для обновления связанных элементов
    inputElement.dispatchEvent(new Event('input', { bubbles: true }))
    inputElement.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
